import { capitalizeFirstLetter } from '@/utils';

export default {
  name: 'CustomQuery',
  components: {
    EmptyState: require('@/customcontrols/emptyState/emptyState.vue').default,
    DataGridComp: require('@/customcontrols/datagrid.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      keyColumn: null,
      appsCols: []
    };
  },
  computed: {
    rows: function () {
      return this.dataObj.appData;
    }
  },
  created() {
    let cap = '';
    if (this.dataObj && this.dataObj.appData && this.dataObj.appData.length > 0) {
      for (const [key, value] of Object.entries(this.dataObj.appData[0])) {
        cap = capitalizeFirstLetter(key);
        this.appsCols.push({ dataField: key, name: cap, caption: cap, type: typeof value });
      }

      this.keyColumn = this.appsCols[0].dataField;
    }
  },
  methods: {
    validateAppData() {
      let validationFailed = false;
      let firstErrorElem = '';

      this.dataObj.forEach((customField) => {
        if (customField.isMandatory) {
          if (
            (customField.type == 0 && !customField.strValue) ||
            (customField.type == 1 && (!customField.intValue || customField.intValue < 0)) ||
            (customField.type == 2 && (!customField.dblValue || customField.dblValue < 0)) ||
            (customField.type == 3 && (!customField.dateValue || isNaN(Date.parse(customField.dateTimeValue)))) ||
            ((customField.type == 4 || customField.type == 5) && !this.validateDropDownSelection(customField)) ||
            (customField.type == 6 && (!customField.dateTimeValue || isNaN(Date.parse(customField.dateTimeValue))))
          ) {
            customField.hasError = true;
            validationFailed = true;

            if (!firstErrorElem) firstErrorElem = customField.customFieldId;
          } else customField.hasError = false;
        } else customField.hasError = false;
      });

      this.$scrollToElement(firstErrorElem, { behavior: 'smooth', block: 'center', inline: 'center' });
      this.$forceUpdate();

      return !validationFailed;
    }
  }
};
